import { Colors } from '@/themes';
import { cn } from '@/utils';
import React, { memo } from 'react';

import { Button as AntButton, ConfigProvider } from 'antd';

import type { ButtonProps } from 'antd';

export interface IButton extends ButtonProps {
	children?: React.ReactNode;
	secondary?: boolean;
	isMainBtn?: boolean;
}

const Button = ({
	children,
	className,
	type = 'default',
	secondary = false,
	disabled = false,
	isMainBtn = false,
	ghost = false,
	...rest
}: IButton) => {
	return (
		<ConfigProvider
			theme={{
				components: {
					Button: {
						contentFontSize: 13,
						fontSize: 13,
						fontWeight: 400,
						colorPrimary: Colors.palette.secondary,
						borderRadius: 4,
						lineHeight: 16,
						controlHeight: 30,
						controlHeightLG: 60,
						colorBorder: Colors.palette.colorBorder,
						defaultColor: Colors.palette.font3,
						ghostBg: '#ffffff',
						paddingInline: 10,
						boxShadow: 'none',
						primaryShadow: 'none',
						boxShadowSecondary: 'none',
						boxShadowTertiary: 'none',
						defaultShadow: 'none',
						dangerShadow: 'none',
					},
				},
			}}
		>
			<AntButton
				className={cn(
					isMainBtn && 'font-medium text-sm min-w-[80px] h-9',
					disabled &&
						{
							primary: '!bg-gray8 !border-gray8 !text-white',
							default: '!bg-white !border-gray1 !text-spanishGray',
							dashed: '!bg-white !border-gray1 !text-spanishGray',
							link: '!text-spanishGray',
							text: '!text-spanishGray',
						}[type],
					disabled && ghost && '!bg-white !border-gray1 !text-spanishGray',
					rest?.icon && 'gap-x-1 min-w-[60px]',
					'xl:rounded-none',
					'hover:underline-offset-2 hover:underline',
					type === 'default' && 'hover:!text-font3 hover:!border-gray1',
					secondary &&
						'bg-blue1 border-blue1 text-white hover:!bg-blue1 hover:!text-white hover:!border-blue1',
					type === 'primary' && !disabled && 'hover:text-white hover:!bg-blue3',
					type === 'primary' &&
						ghost &&
						'hover:!bg-white hover:!text-blue3 hover:!border-blue3',
					className
				)}
				type={type}
				ghost={ghost}
				disabled={disabled}
				{...rest}
			>
				{children}
			</AntButton>
		</ConfigProvider>
	);
};

export default memo(Button);
